// extracted by mini-css-extract-plugin
module.exports = {"base":"styles_base__PDmOj","card":"styles_card__8oEgj"};